import { AppThunk } from 'redux/store';
import { TypesWPContent } from './type';
import WebApi from 'core/services/WebApi';

export const getWPContent = (): AppThunk<void> => (dispatch) => {
  dispatch({ type: TypesWPContent.GET_WP_CONTENT_REQUEST });

  return WebApi.request({
    method: 'GET',
    url: '/data',
    isWP: true,
    onSuccess: (data) => {
      dispatch({
        type: TypesWPContent.GET_WP_CONTENT_SUCCESS,
        data: {
          ...data,
          footer: {
            ...data.footer,
            modal_info: data.footer.menu,
            menu: data.footer.menu,
          },
        },
      });
    },
    onFailed: () => {
      dispatch({ type: TypesWPContent.GET_WP_CONTENT_FAILED });
    },
    isAuth: false,
  });
};
